//@ts-nocheck
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { connect } from 'react-redux'
// import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux'
import Header from './components/header/header'
import './App.css'
import Nav from './components/navBar/nav'
import Main from './components/main/main'
import Footer from './components/footer/footer'
import MyPreloader from './components/commons/preloader/preloader'
// import { LinkedInPopUp } from 'react-linkedin-login-oauth2';
import AdminPage from './components/adminPage/adminPage'
import { Helmet } from 'react-helmet'
import icon from './assets/books.png'
import { RootState } from './redux/store'
import withRouter from './hooks/withRouter'
import { setLanguage } from './redux/main.slice'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthUser } from './types/user'

const SignUp = lazy(() => import('./components/signUp/signUp'))
const SignIn = lazy(() => import('./components/signIn/signIn'))
// const ConfirmEmail = lazy(
//   () => import('./components/confirmEmail/confirmEmail'),
// )
// const ConfirmationEmail = lazy(
//   () => import('./components/confirmEmail/confirmationEmail'),
// )
const UserPage = lazy(() => import('./components/user/user'))
const BookCategory = lazy(
  () => import('./components/bookCategory/bookCategory'),
)
const AuthorPublisher = lazy(
  () => import('./components/authorPublisher/authorPublisher'),
)
const Book = lazy(() => import('./components/book/book'))
const Basket = lazy(() => import('./components/basket/basket'))
const Search = lazy(() => import('./components/search/search'))
const Contacts = lazy(() => import('./components/contacts/contacts'))
const About = lazy(() => import('./components/aboutUs/aboutUs'))
const NotFound = lazy(() => import('./components/notFound/notFound'))

interface AppState {
  words: any
  authUser: AuthUser
  setLanguage: (lang: string) => void
}

const App = (props: AppState) => {
  const { words, authUser, setLanguage } = props
  const [aboutUs, setAboutUs] = useState([
    words.about1,
    words.about2,
    words.about3,
    words.about4,
    words.about5,
  ])
  const [forAuthors, setForAuthors] = useState([
    words.forAuthorsText1,
    words.forAuthorsText2,
    words.forAuthorsText3,
    words.forAuthorsText4,
    words.forAuthorsText5,
    words.forAuthorsText6,
  ])
  const [forPublishers, setForPublishers] = useState([
    words.forPublishersText1,
    words.forPublishersText2,
    words.forPublishersText3,
    words.forPublishersText4,
    words.forPublishersText5,
    words.forPublishersText6,
    words.forPublishersText7,
  ])
  const [returnBooks, setReturnBooks] = useState([
    words.returnText1,
    words.returnText2,
    words.returnText3,
    words.returnText4,
  ])

  const [delivery, setDelivery] = useState([words.deliveryText1])

  useEffect(() => {
    const language = localStorage.getItem('language')
    if (language) {
      setLanguage(language)
    }
  }, [])

  return (
    <div className="App">
      <Helmet>
        {/* @ts-ignore */}
        <meta charset="utf-8" />
        <title>BOOKLY</title>
        <link rel="icon" href={icon} />
        <meta
          name="description"
          lang="es"
          content="Bookly es una tienda online de libros, que ubicada en la Barcelona"
        />
        <meta
          name="keywords"
          lang="es"
          content="bookly,books,barcelona,authors,libros"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="author" content="Arman Gharibyan" />
        <script
          src="https://kit.fontawesome.com/72d6db34bf.js"
          //@ts-ignore
          crossorigin="anonymous"
        ></script>
        <meta name="robots" content="all" />
      </Helmet>
      {/* @ts-ignore */}
      <Header />
      <Nav />
      <Routes>
        <Route path="/" element={<Navigate to="/main" replace />} />
        <Route path="/main" element={<Main />} />
        <Route
          path="/sign_up"
          element={
            <Suspense fallback={<MyPreloader />}>
              <SignUp />
            </Suspense>
          }
        />
        {/* <Route exact path="/sign_in/linked_in" component={LinkedInPopUp} /> */}
        <Route
          path="/sign_in"
          element={
            <Suspense fallback={<MyPreloader />}>
              <SignIn />
            </Suspense>
          }
        />
        {/* <Route
          path="/confirm_email"
          render={() => (
            <Suspense fallback={<MyPreloader />}>
              <ConfirmEmail />
            </Suspense>
          )}
        /> */}
        {/* <Route
          path="/authentication/activate/:token"
          render={() => (
            <Suspense fallback={<MyPreloader />}>
              <ConfirmationEmail />
            </Suspense>
          )}
        /> */}
        <Route
          path="/my_account/*"
          element={
            <Suspense fallback={<MyPreloader />}>
              <UserPage />
            </Suspense>
          }
        />
        <Route
          path="/books/categories/:category"
          element={
            <Suspense fallback={<MyPreloader />}>
              <BookCategory />
            </Suspense>
          }
        />
        <Route
          path="/books/:id/:name"
          element={
            <Suspense fallback={<MyPreloader />}>
              <Book />
            </Suspense>
          }
        />
        <Route
          path="/authors/:id/:name"
          element={
            <Suspense fallback={<MyPreloader />}>
              <AuthorPublisher />
            </Suspense>
          }
        />
        <Route
          path="/publishers/:id/:name"
          element={
            <Suspense fallback={<MyPreloader />}>
              <AuthorPublisher />
            </Suspense>
          }
        />
        <Route
          path="/basket"
          element={
            <Suspense fallback={<MyPreloader />}>
              <Basket />
            </Suspense>
          }
        />
        <Route
          path="/search/:name"
          element={
            <Suspense fallback={<MyPreloader />}>
              <Search />
            </Suspense>
          }
        />
        <Route
          path="/contacts"
          element={
            <Suspense fallback={<MyPreloader />}>
              <Contacts />
            </Suspense>
          }
        />
        <Route
          path="/about_us"
          element={
            <Suspense fallback={<MyPreloader />}>
              <About textArray={aboutUs} title={words.aboutUs} />
            </Suspense>
          }
        />
        <Route
          path="/for_authors"
          element={
            <Suspense fallback={<MyPreloader />}>
              <About textArray={forAuthors} title={words.forAuthors} />
            </Suspense>
          }
        />
        <Route
          path="/for_publishing_houses"
          element={
            <Suspense fallback={<MyPreloader />}>
              <About
                textArray={forPublishers}
                title={words.forPublishinghouses}
              />
            </Suspense>
          }
        />
        {/* <Route
          path="/return"
          render={() => (
            <Suspense fallback={<MyPreloader />}>
              <About textArry={returnBooks} title={words.return} />
            </Suspense>
          )}
        /> */}
        {/* <Route
          path="/delivery"
          render={() => (
            <Suspense fallback={<MyPreloader />}>
              <About textArry={delivery} title={words.delivery} />
            </Suspense>
          )}
        /> */}
        <Route
          path="/admin"
          element={authUser ? <AdminPage /> : <NotFound />}
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<MyPreloader />}>
              <NotFound />
            </Suspense>
          }
        />
        {/* <Route path="/main" render={() => <Main />} /> */}
      </Routes>
      <Footer />
    </div>
  )
}

let mapStateToProps = (state: RootState) => ({
  words: state.main.words,
  authUser: state.user.authUser,
})

export default compose(
  connect(mapStateToProps, { setLanguage }),
  withRouter,
)(App)
